import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import * as styles from './PostPlatformPreview.scss';

function InstagramPreview(props) {
  var _ref;

  var account = props.account,
      igImageSlideIndex = props.igImageSlideIndex,
      images = props.images,
      message = props.message,
      setImageSlideIndex = props.setImageSlideIndex,
      videos = props.videos;
  var m = message && message.replace(/\s+/g, '') ? /*#__PURE__*/React.createElement("span", {
    className: styles.ig_post
  }, message) : /*#__PURE__*/React.createElement("i", null, "Type a message to see the preview here.");
  var accountInfo = {
    profileImage: 'https://s3.amazonaws.com/likeabucket/user_upload/232/h-q1C_CMb.jpeg',
    profileUsername: 'username'
  };

  if (account) {
    accountInfo.profileImage = account.avatarImageUrl;
    accountInfo.profileUsername = account.username;
  }

  var videoLink = null;

  if (videos && videos.length > 0) {
    videoLink = videos[0];
  }

  return /*#__PURE__*/React.createElement("article", {
    className: styles.igArticle
  }, /*#__PURE__*/React.createElement("header", {
    className: styles.igHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.igProfileImageWrap
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.igProfileImage,
    src: accountInfo.profileImage
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.igProfileNameWrap
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.igProfileName
  }, accountInfo.profileUsername)), /*#__PURE__*/React.createElement("div", {
    className: styles.igProfileTimeWrap
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.igProfileTime
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.igImageContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.igImageWrap,
    style: videoLink ? {
      paddingBottom: 0
    } : {}
  }, !videoLink && images.length > 0 ? images.map(function (image, idx) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.igImage,
      style: {
        backgroundImage: "url(".concat(image, ")"),
        left: (idx - igImageSlideIndex) * 525
      }
    });
  }) : null, videoLink && (videoLink.indexOf('blarplesnurf') === -1 || videoLink.indexOf('blarplesnurf-staging') === -1) ? /*#__PURE__*/React.createElement("video", {
    style: {
      width: '100%',
      height: '100%'
    },
    src: videoLink,
    autoPlay: true,
    loop: true,
    controls: true,
    muted: true
  }) : null, videoLink && (videoLink.indexOf('blarplesnurf') !== -1 || videoLink.indexOf('blarplesnurf-staging') !== -1) ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Your video is being processed. One moment..."), /*#__PURE__*/React.createElement("i", {
    className: "fa fa-spinner fa-spin"
  })) : null))), !videoLink && /*#__PURE__*/React.createElement("div", {
    style: (_ref = {
      alignItems: 'center',
      position: 'absolute',
      top: 64,
      height: 525
    }, _defineProperty(_ref, "height", 525), _defineProperty(_ref, "width", 525), _defineProperty(_ref, "display", 'flex'), _ref)
  }, igImageSlideIndex > 0 ? /*#__PURE__*/React.createElement("button", {
    className: styles.igImageSwitchButton,
    onClick: function onClick() {
      if (igImageSlideIndex > 0) {
        setImageSlideIndex(igImageSlideIndex - 1);
      }
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-chevron-left"
  })) : /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }), igImageSlideIndex < images.length - 1 ? /*#__PURE__*/React.createElement("button", {
    className: styles.igImageSwitchButton,
    onClick: function onClick() {
      if (igImageSlideIndex < images.length - 1) {
        setImageSlideIndex(igImageSlideIndex + 1);
      }
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-chevron-right"
  })) : /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.igCommentContainer
  }, /*#__PURE__*/React.createElement("section", {
    className: styles.igLikeSection,
    style: {
      textAlign: 'center',
      marginTop: 3
    }
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      position: 'absolute',
      left: 0,
      width: 120,
      marginLeft: -20
    },
    src: "https://s3.amazonaws.com/likeabucket/user_upload/232/qw5icZ0g1Y.png"
  }), /*#__PURE__*/React.createElement("img", {
    style: {
      position: 'absolute',
      right: 0,
      width: 48,
      marginRight: -15
    },
    src: "https://s3.amazonaws.com/likeabucket/user_upload/232/84GKhucEb.png"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.igLikeWrap
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.igLikes
  }, !videoLink && images.length > 1 ? images.map(function (_, idx) {
    return /*#__PURE__*/React.createElement("span", {
      style: {
        padding: 2
      }
    }, /*#__PURE__*/React.createElement("i", {
      style: _objectSpread({
        fontSize: 8
      }, idx === igImageSlideIndex ? {
        color: '#3897f0'
      } : {
        color: '#dbdbdb'
      }),
      className: "fa fa-circle ".concat(styles.igImgDot)
    }));
  }) : null))), /*#__PURE__*/React.createElement("section", {
    className: styles.igLikeSection
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.igLikeWrap
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.igLikes
  }, /*#__PURE__*/React.createElement("span", null, "64 likes")))), /*#__PURE__*/React.createElement("ul", {
    className: styles.igCommentList
  }, /*#__PURE__*/React.createElement("li", {
    className: styles.igCommentWrap
  }, /*#__PURE__*/React.createElement("h1", null, /*#__PURE__*/React.createElement("div", {
    className: styles.igCommentUsername
  }, accountInfo.profileUsername), /*#__PURE__*/React.createElement("p", {
    id: "test-ig-message"
  }, m))))));
}

export default InstagramPreview;